import { TextFieldProps } from 'formik-material-ui'
import { useField } from 'formik'
import { Counter, TextField } from './TextAreaWithCounter.style'

interface TextAreaWithCounterProps extends TextFieldProps {
  maxChars: number
  hideCounter?: boolean
}

const TextAreaWithCounter = ({
  maxChars,
  hideCounter,
  ...props
}: TextAreaWithCounterProps) => {
  const { field } = props

  const [, meta] = useField(field?.name)

  const isError = !!(meta.error && meta.touched)
  return (
    <TextField
      {...props}
      InputProps={{
        endAdornment: !hideCounter && (
          <Counter isError={isError}>{`${
            field?.value?.length || 0
          }/${maxChars}`}</Counter>
        ),
      }}
    />
  )
}

export default TextAreaWithCounter
